import React from 'react'
import { Box, Button } from '@mui/material'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import Modal from '../../common/modal'
const DestinationChangeRemarkMode = ({updateModal,setTextAreaValue,setShowModel,updateSendetReceiverDetails}) => {

    const handleSave =()=>{
        updateSendetReceiverDetails()
    }
    const handleRemark =(value)=>{
       setTextAreaValue(value)
    }
  return (
    <Modal headTxt={`Destination Change Remark`} width={'50%'} updateModal={updateModal}>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', margin: '15px' }}>
                <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '100px', marginBottom: '10px' }}>
                    <textarea
                        className="ticket-textarea"
                        id="rulesInput"
                        name="rulesInput"
                        // value={selectedFormtatData.RulesAndRegulations || ''}
                        onChange={(e) => handleRemark(e.target.value)}
                        rows="10"
                        placeholder="Type Your Remarks here..."
                        style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            borderRadius: '6px',
                            borderColor: '#00000026',
                            padding: '15px',
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#444444',
                            // borderColor: borderColor,
                        }}
                    // onKeyDown={(e) => navigation1(e, 'declaration', 'website')}
                    // onFocus={handleFocus}
                    // onBlur={handleBlur}
                    />
                </Box>
                <Item sx={sx.itemsx} style={{ textAlign: 'right' }}>
                    <Button variant="contained" className="go click-button" onClick={handleSave}>
                        SAVE
                    </Button>
                </Item>
            </Box>
        </Modal>
  )
}

export default DestinationChangeRemarkMode